// Shared age helper. A patient has exactly one of date_of_birth / age_years
// set (enforced server-side) — DOB is preferred when present since it's
// exact; age_years is the fallback for patients registered without a known
// DOB.

function ageFromDob(dateOfBirth: string): number | null {
  const dob = new Date(dateOfBirth);
  if (isNaN(dob.getTime())) return null;
  const today = new Date();
  let age = today.getFullYear() - dob.getFullYear();
  const monthDiff = today.getMonth() - dob.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
    age--;
  }
  return age;
}

export function getPatientAge(
  dateOfBirth?: string | null,
  ageYears?: number | null,
): number {
  if (dateOfBirth) {
    const fromDob = ageFromDob(dateOfBirth);
    if (fromDob !== null) return fromDob;
  }
  return ageYears ?? 0;
}
